export class SurPicklistLookupModel {
  HospitalId = '';
  PicklistName = '';
}
